import { Link } from 'foundations-components/transitional/components/Link';
import { useTaskLink } from '../../../hooks/hub';
import { jsx as _jsx } from "react/jsx-runtime";
const DependencyTaskLink = ({
  dependencyTask,
  onClick
}) => {
  const {
    handholdingEnabled,
    id,
    link,
    name,
    handholdingGroupKeyOverride,
    handholdingSource
  } = dependencyTask;
  const taskLink = useTaskLink(link, id, handholdingEnabled, handholdingGroupKeyOverride, handholdingSource);
  return /*#__PURE__*/_jsx(Link, {
    href: taskLink,
    onClick: onClick,
    children: name
  });
};
export default DependencyTaskLink;